export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 486
// module chunks = 77